import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Breakpoint } from "react-socks"

import { Container, SubmitButton as Button, Email } from "../inputs"

const useSignupForm = () => {
  const [inputs, setInputs] = useState({ email: "" })
  const handleChange = evt => {
    evt.persist()
    setInputs(inputs => ({
      ...inputs,
      [evt.target.name]: evt.target.value,
    }))
  }
  const handleSubmit = evt => {
    evt.preventDefault()

    const params = Object.keys(inputs).reduce(
      (sum, input, i, arr) =>
        sum + `${input}=${inputs[input]}${i + 1 === arr.length ? "" : "&"}`,
      "?"
    )
    window.open(`https://admin.kamva.ir/register${params}`, "_blank")
  }
  return {
    inputs,
    handleChange,
    handleSubmit,
  }
}

const SignUp = ({ hasBorder }) => {
  const { inputs, handleChange, handleSubmit } = useSignupForm()
  const data = useStaticQuery(
    graphql`
      {
        yaml: contentYaml(header: { slug: { eq: "/index" } }) {
          content {
            signup {
              placeholder
              text
            }
          }
        }
      }
    `
  )
  const { text, placeholder } = data.yaml.content.signup

  return (
    <form onSubmit={handleSubmit}>
      <Container valign="center" hasBorder={hasBorder}>
        <Email
          id="email"
          name="email"
          placeholder={placeholder}
          onChange={handleChange}
          value={inputs.email}
          required={false}
        />
        <label htmlFor="email" style={{ fontSize: 0 }}>
          Email
        </label>
        <Breakpoint mobile up className="button-container">
          <Button
            text={text}
            name={text}
            type="submit"
            style={{ padding: "16px" }}
          />
        </Breakpoint>
      </Container>
      <Breakpoint only base>
        <Button
          text={text}
          name={text}
          type="submit"
          style={{ marginTop: "16px" }}
        />
      </Breakpoint>
    </form>
  )
}

export default SignUp
